import { AlertTriangle, RefreshCw } from "lucide-react";
import { useState } from "react";
import { useFormContext, useWatch } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { toast } from "sonner";
import { Alert, AlertDescription } from "@/components/ui/alert";
import { Button } from "@/components/ui/button";
import type { RewardsConfig } from "../hooks/use-rewards-config";

export function AdvancedSettings() {
  const { control } = useFormContext<RewardsConfig>();
  const { t } = useTranslation("settings");
  const loyaltyProgramEnabled = useWatch({ control, name: "loyaltyProgramEnabled" });
  const enabled = useWatch({ control, name: "enabled" });
  const [isRecalculating, setIsRecalculating] = useState(false);

  if (!loyaltyProgramEnabled || !enabled) {
    return null;
  }

  const handleRecalculatePoints = async () => {
    // TODO: Implement actual recalculation logic with BullMQ job
    setIsRecalculating(true);

    try {
      // Placeholder for future implementation
      await new Promise((resolve) => setTimeout(resolve, 2000));

      toast.info(
        "Points recalculation feature is not yet implemented. This will be added in a future update."
      );
    } catch (_error) {
      toast.error("Failed to start points recalculation");
    } finally {
      setIsRecalculating(false);
    }
  };

  return (
    <div className="space-y-4">
      <Alert>
        <AlertTriangle className="h-4 w-4" />
        <AlertDescription>
          <strong>{t("rewards.pointsRecalculation")}</strong>
          <br />
          {t("rewards.pointsRecalculationDescription")}
        </AlertDescription>
      </Alert>

      <div className="flex flex-col gap-2">
        <Button
          variant="outline"
          onClick={handleRecalculatePoints}
          disabled={isRecalculating}
          className="w-fit"
        >
          <RefreshCw className={`h-4 w-4 mr-2 ${isRecalculating ? "animate-spin" : ""}`} />
          {isRecalculating ? t("rewards.recalculating") : t("rewards.recalculateAllPoints")}
        </Button>

        <p className="text-xs text-muted-foreground">{t("rewards.recalculationTodo")}</p>
      </div>
    </div>
  );
}
